import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, ChangeDetectorRef, Input, NgModule, effect } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CompanyProperties } from '@shared/constants';
import { InvoicesFilterService } from '@core/services/system/invoice-filter.service';
import { SecurityService } from '@core/services/system/security.service';
import { TableEnforceService } from '@core/services/system/table-select-enforcement.service';
import { SetTimeoutUtil } from '@core/services/utils/settimeout.utils';
import { fadeElm } from '@shared/animations';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'no-invoices',
  templateUrl: './no-invoices.component.html',
  styleUrls: ['./no-invoices.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fadeElm()],
})
export class NoInvoicesComponent implements OnInit {
  @Input() isPossibleAddInvoice: boolean = true;
  @Input() isOnlineInvoice: boolean = false;
  public currentFilterSet: any = {};
  public showContent: boolean = false;
  public isTableForce: boolean = false;

  constructor(
    private tableEnforceService: TableEnforceService,
    private securityService: SecurityService,
    private invoicesFilterService: InvoicesFilterService,
    private setTimeoutUtil: SetTimeoutUtil,
    private cdr: ChangeDetectorRef
  ) {
    this.initTableEnforcedEffect();
    this.initInvoiceFilterEffect();
  }

  private initTableEnforcedEffect(): void {
    const tableEnforcedSignal = toSignal(
      this.securityService.observableCompanyProperties(CompanyProperties.tablesEnforced),
      { initialValue: undefined }
    );
    effect(() => {
      const company = tableEnforcedSignal();
      if (company === undefined) return;
      this.isTableForce = company.tablesEnforced;
      this.cdr.markForCheck();
    });
  }

  private initInvoiceFilterEffect(): void {
    const invoiceFilterSignal = toSignal(this.invoicesFilterService.getInvoiceFilter(), { initialValue: undefined });
    effect(() => {
      const data = invoiceFilterSignal();
      if (data === undefined) return;
      if (data && data.tab) {
        this.currentFilterSet = data;
        this.cdr.markForCheck();
      }
    });
  }

  ngOnInit() {
    this.isTableForce = this.tableEnforceService.checkForTableEnforcement();
    this.setTimeoutUtil.addVisualEffect(100).then(() => {
      this.showContent = true;
      this.cdr.markForCheck();
    });
  }

  addNewInvoice() {
    const { table, tab } = this.currentFilterSet;
    if (tab === 'paid' || tab === 'open' || tab === 'no' || table === 'all') {
      this.invoicesFilterService.newInvoice();
      return;
    }
    this.invoicesFilterService.newTableInvoice();
  }
}
@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule.forChild(),
  ],
  declarations: [NoInvoicesComponent],
  exports: [NoInvoicesComponent],
})
export class NoInvoicesComponentModule {}
